module.exports = __webpack_public_path__ + "static/media/banner-0-my.ce8a112c.jpg";